import { getServerApi } from '@/gql';
import user from '@/stores/user';
import { useState } from 'react';

export interface UsePersonalityAvailableResult {
    personalityAvailable: boolean | null;
    loading: boolean;
    error: Error | null;
    getPersonalityAvailable: () => Promise<boolean | null>;
}

export const usePersonalityAvailable = (
    tokenId: number,
): UsePersonalityAvailableResult => {
    const [personalityAvailable, setPersonalityAvailable] = useState<
        boolean | null
    >(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getPersonalityAvailable = async () => {
        if (!tokenId || !userId) {
            setPersonalityAvailable(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.personalityAvailable({
                tokenId: tokenId,
            });
            if (response?.personalityAvailable !== undefined) {
                setPersonalityAvailable(response.personalityAvailable);
                return response.personalityAvailable;
            } else {
                setPersonalityAvailable(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch personality available:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch personality available'),
            );
            setPersonalityAvailable(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        personalityAvailable,
        loading,
        error,
        getPersonalityAvailable,
    };
};
